import styled from 'styled-components';

export const HeaderContainer = styled.div`
  top: 0;
  //   background-color: ${(props) => props.theme.colors.gray2};
  width: 100%;
  .hefesto-header__nav {
    display: none;
  }
`;

export const UserEvaluationContent = styled.div`
  margin-top: 5rem;
`;
